import React from 'react';

/* does this need to be a component? probably not */
const Goose = () => {
    return (
        <div className="img">
            <img src="./chonk.png" alt="chonky goose"/>
        </div>
    );
};

export default Goose;